<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col sm="12" md="6">
          <p class="step_title">Source des résultats</p>
          <b-form-select size="sm" v-model="selectedExport" :options="list_exports"
            @input="$emit('changeSelectedExport', selectedExport)"></b-form-select>
          <hr />
          <p class="step_instruction">Uniquement si votre chrono est hors connexion, vous pouvez importer le GMCAP
            depuis votre ordinateur.</p>
          <input type="file" @change="onExportImported" />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Axios from "axios";
import Papa from "papaparse";
export default {
  props: ["list_exports", "old_export_url", "old_source_export"],
  data() {
    return {
      selectedExport: null,
    };
  },
  methods: {
    onExportImported(e) {
      var _this = this;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      var res = { filename: files[0].name, content: [] };
      var data = new FormData();
      data.append("export", files[0], files[0].name);
      Axios.post(this.$store.getters.base_url + "/import/export/upload.php", data);
      Papa.parse(files[0], {
        skipEmptyLines: true,
        header: true,
        encoding: "ISO-8859-1",
        complete: function (content) {
          res.content = content;
          _this.$emit("uploadExport", res);
        },
      });
    },
  },
  mounted() {
    if (this.old_export_url !== "" && this.old_source_export === "server") {
      for (var i = 0; i < this.list_exports.length; i++) {
        if (this.old_export_url.includes(this.list_exports[i].value)) {
          this.selectedExport = this.list_exports[i].value;
          this.$emit("changeSelectedExport", this.selectedExport);
          break;
        }
      }
    }
  },
};
</script>

<style>
.choice_text {
  text-align: center !important;
  margin: 15px 0 !important;
  color: #f29200;
  font-weight: bold;
  font-size: 24px;
}
</style>